import type { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}

export default function Card({ children, className = '', onClick }: CardProps) {
  return (
    <div
      onClick={onClick}
      className={`rounded-lg border border-background-200 bg-background-50 ${onClick ? 'cursor-pointer transition-colors hover:border-primary-300' : ''} ${className}`}
    >
      {children}
    </div>
  );
}